import { State } from '../../index'
import { selectTemplateDetail } from '../../campaignTemplates'
import { PlaceholderKeyData } from 'services/api/campaignTemplates'

interface TemplatePreviewData {
    taskElementUuid?: string
    taskTitle?: string
    step?: PlaceholderKeyData
}

export const selectTemplateFirstStepDataByTaskIndex =
    (index: number) =>
    (state: State): TemplatePreviewData => {
        const selectTaskElement = selectTemplateDetail(state)?.task_elements[index]
        const firstStepData = selectTaskElement?.data?.steps[0]
        return {
            taskElementUuid: selectTaskElement?.uuid,
            taskTitle: selectTaskElement?.data?.title,
            step: firstStepData?.data ? { ...firstStepData?.data } : undefined,
        }
    }
